<template>
  <div class="fff">
    <div class="tab">
      <div :class="isshow == 0 ? 'tab_li mr' : 'tab_li'" @click="isshow = 0">
        {{ $t("gps.list") }}
        <div></div>
      </div>
      <div :class="isshow == 1 ? 'tab_li mr' : 'tab_li'" @click="changeShow(1)">
        {{ $t("gps.map") }}
        <div></div>
      </div>
    </div>
    <div class="LIist" v-show="isshow == 0">
      <div class="timeAll_w">
        <el-date-picker
          v-model="value1"
          class="timeAll"
          type="daterange"
          @change="getlist"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-dropdown @command="handleCommand" class="timeDow">
          <span
            class="el-dropdown-link"
            :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
          >
            {{ $t("Last days Days", { days: days })
            }}<i
              class="el-icon-caret-bottom el-icon--right"
              :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="7">{{
              $t("gps.num1")
            }}</el-dropdown-item>
            <el-dropdown-item command="30">{{
              $t("gps.num2")
            }}</el-dropdown-item>
            <el-dropdown-item command="60">{{
              $t("gps.num3")
            }}</el-dropdown-item>
            <el-dropdown-item command="90">{{
              $t("gps.num4")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <table class="mytable">
        <tr>
          <th>{{ $t("gps.latitude") }}</th>
          <th>{{ $t("gps.longitude") }}</th>
          <th>{{ $t("gps.accuracy") }}</th>
          <th>{{ $t("gps.map") }}</th>
          <th>{{ $t("gps.address") }}</th>
          <th>{{ $t("gps.time") }}</th>
        </tr>
        <tr v-for="(val, key) in list" :key="key">
          <td>{{ val.latitude }}</td>
          <td>{{ val.longitude }}</td>
          <td>{{ val.accuracy }}</td>
          <td>
            <a @click="changeShow(1)" style="cursor: pointer">{{
              $t("gps.google")
            }}</a>
          </td>
          <td class="address">{{ val.address }}</td>
          <td>{{ val.createtime }}</td>
          <!-- <td>{{new Date(val.createtime*1000).toLocaleString().replace(/:\d{1,2}$/,' ')}}</td> -->
        </tr>
      </table>

      <div class="noData" v-if="list.length <= 0 && status">
        {{ $t("gps.no") }}
      </div>
      <div class="pagination" v-if="code > 0">
        <el-pagination
          @current-change="setPage"
          background
          layout="prev, pager, next"
          :total="code"
          page-size="20"
        >
        </el-pagination>
      </div>
    </div>
    <div class="Map" v-show="isshow == 1">
      <!-- <div class="google-map" id="map1"></div> -->
      <div class="mapbox-maps" v-if="showMap">
        <div id="map1" ref="basicMapbox" style="height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Gps, getMapKeys } from "@/api/user";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
// eslint-disable-next-line no-unused-vars
const TILE_SIZE = 256;
export default {
  name: "HelloWorld",
  data() {
    return {
      mapInst: "",
      // 组件加载后隐藏
      infowindows: [],
      map: null,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
      days: 90,
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 20,
        starttime: "",
        endtime: "",
      },
      code: 0,
      value1: "", // 获取时间
      list: [],
      isshow: 0,
      msg: "",
      isChecked: null,
      status: false,
      mapDataCopy: [], // 标记点数据
      currentMarkers: [], //标记点集合
      showMap: false,
    };
  },
  mounted() {
    let data = [this.lng, this.lat];
    this.mapDataCopy = JSON.parse(JSON.stringify(data));
    this.handleCommand();
  },
  methods: {
    changeShow(index) {
      this.isshow = index;
      this.$nextTick(() => {
        if (this.list.length > 0) {
          this.lat = Number(this.list[0].latitude);
          this.lng = Number(this.list[0].longitude);
        }
        this.showMap = false;
        this.initMap();
      });
    },
    // initMap () {
    //   // eslint-disable-next-line no-undef
    //   const mapDiv = new google.maps.Map(document.getElementById('map1'), {
    //     center: {
    //       lat: this.lat,
    //       lng: this.lng
    //     },
    //     zoom: 15,
    //     maxZoom: 20,
    //     minZoom: 3,
    //     streetViewControl: false,
    //     mapTypeControl: false,
    //     disableDefaultUI: false,
    //     zoomControl: false,
    //     scaleControl: false
    //   })
    //   this.map = mapDiv
    //   if (this.list.length > 0) {
    //     this.handLigature()
    //   }
    // },
    async initMap(row) {
      this.showMap = true;
      const ddd = await getMapKeys();
      let myIcon = L.icon({
        iconUrl: require("./../assets/img/lastMap.png"),
        iconSize: [27, 40],
        iconAnchor: [15, 32],
      });

      this.map = L.map("map1", {
        center: [this.lat, this.lng], // 地图中心
        zoom: 15, //缩放比列
        zoomControl: false, //禁用 + - 按钮
        doubleClickZoom: false, // 禁用双击放大
        attributionControl: false, // 移除右下角leaflet标识
      });
      // styles/
      let name = L.tileLayer(
        // "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        // "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png"
        `https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${ddd.data.key}`,
        {
          minZoom: 5,
          maxZoom: 18,
        }
      ).addTo(this.map);

      if (this.list.length > 0) {
        var latlngs = this.list.map((item) => {
          return [item.latitude, item.longitude];
        });
        let polyline = L.polyline(latlngs, {
          color: "#289329",
        }).addTo(this.map);
        this.map.fitBounds(polyline.getBounds());
        let datas = this.$arrGroup(
          this.list,
          (item) => item.latitude && item.longitude
        );
        let popups = this.$initMapPopups(datas);
        function marker(list, map, index = 0) {
          L.marker([list[index].latitude, list[index].longitude], {
            icon: myIcon,
          })
            .addTo(map)
            .on("click", function () {
              map.openPopup(
                popups[[list[index].latitude, list[index].longitude]]
              );
            });
          if (list.length - 1 > index) {
            marker(list, map, index + 1);
          }
        }
        marker(this.list, this.map);
      }
    },
   
    handleCommand(event) {
      let end = new Date();
      let start = new Date(new Date().setDate(end.getDate() - 90));
      if (event) {
        this.days = event;
        start = new Date();
        this.isChecked = true;
        start.setTime(start.getTime() - 3600 * 1000 * 24 * event);
      }
      this.value1 = [start, end];
      this.getlist();
    },
    setPage(e) {
      this.key.page = e;
      this.getlist();
    },
    getlist(a) {
      this.status = false;
      this.key.starttime =
        this.value1[0].getFullYear() +
        "-" +
        (this.value1[0].getMonth() < 9 ? "0" : "") +
        (this.value1[0].getMonth() + 1) +
        "-" +
        (this.value1[0].getDate() < 10 ? "0" : "") +
        this.value1[0].getDate();
      this.key.endtime =
        this.value1[1].getFullYear() +
        "-" +
        (this.value1[1].getMonth() < 9 ? "0" : "") +
        (this.value1[1].getMonth() + 1) +
        "-" +
        (this.value1[1].getDate() < 10 ? "0" : "") +
        this.value1[1].getDate();
      if (a) {
        this.key.page = a;
      }
      this.list = [];
      Gps(this.key).then((adj) => {
        this.list = adj.data.list;
        this.code = adj.data.count;
        this.status = true;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.css");
.address {
  width: 35%;
  padding: 2px 0;
  text-indent: 0px;
}
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.mytable {
  width: 95%;
}
.mytable a {
  color: #0080ff;
}
.Map {
  width: 100%;
  height: 750px;
  background: #eee;
}
.google-map {
  width: 100%;
  height: 750px;
}
.mapboxgl-map {
  width: 100%;
  height: 750px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.mapboxgl-canvas {
  outline: none;
}
.mapboxgl-ctrl-logo {
  display: none;
}
.mapbox-maps {
  width: 100%;
  height: 750px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/GPS.vue